import { useEffect, useState } from "react";
import { Loader2, Tag } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

const PERIODS = [[7, "7 días"], [30, "30 días"], [90, "90 días"]];
const COLS = ["Destino", "Tocaron", "Compartieron", "Fueron a comprar", "Pidieron aviso", "Pasajes vendidos", "Promo"];

const Bar = ({ value, max }) => (
  <span className="mt-1 block h-1.5 w-full max-w-[120px] overflow-hidden rounded-full bg-black/5">
    <span className="block h-full rounded-full bg-[var(--forest)]" style={{ width: `${max ? Math.round((value / max) * 100) : 0}%` }} />
  </span>
);

const StatRow = ({ r, max, i, onPromo }) => (
  <tr data-testid={`dest-stat-${r.city}`} className="border-t border-black/5">
    <td className="py-3 pr-3"><b>{i + 1}. {r.city}</b>{r.top_origin && <span className="block text-xs text-[var(--muted-ink)]">más elegido desde {r.top_origin}</span>}</td>
    <td className="py-3 pr-3 font-semibold" data-testid={`dest-stat-${r.city}-open`}>{r.open}<Bar value={r.open} max={max} /></td>
    <td className="py-3 pr-3" data-testid={`dest-stat-${r.city}-share`}>{r.share}</td>
    <td className="py-3 pr-3" data-testid={`dest-stat-${r.city}-buy`}>{r.buy}</td>
    <td className="py-3 pr-3" data-testid={`dest-stat-${r.city}-alerts`}>{r.alerts}</td>
    <td className="py-3 pr-3" data-testid={`dest-stat-${r.city}-sold`}>{r.sold}</td>
    <td className="py-3 pr-3">
      {r.promo_pct
        ? <span data-testid={`dest-stat-${r.city}-promo`} className="rounded-full bg-[var(--lime)] px-2.5 py-1 text-xs font-bold">-{r.promo_pct}% vigente</span>
        : <button type="button" onClick={() => onPromo(r)} data-testid={`dest-stat-${r.city}-create-promo`} className="inline-flex items-center gap-1 rounded-full bg-[var(--forest)] px-3 py-1.5 text-xs font-bold text-white transition-transform hover:-translate-y-0.5"><Tag className="h-3 w-3" /> Crear promo</button>}
    </td>
  </tr>
);

/** Ranking de destinos por interés en la franja de la portada, para decidir dónde hacer promos. */
export const DestStats = ({ go }) => {
  const [days, setDays] = useState(30);
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setRows(null);
    api.get("/admin/dest-stats", { params: { days } }).then((r) => setRows(Array.isArray(r.data?.rows) ? r.data.rows : []))
      .catch((e) => { toast.error(apiError(e)); setRows([]); });
  }, [days]);
  const max = Math.max(0, ...(rows || []).map((r) => r.open));
  const onPromo = (r) => go("promos", { destination: r.city, origin: r.top_origin || "Retiro" });
  return (
    <div data-testid="report-dest-stats" className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="max-w-xl text-sm text-[var(--muted-ink)]">Qué destinos tocan, comparten y van a comprar los pasajeros desde la franja de la portada. Los de mucho interés y pocas ventas son buenos candidatos para una promo.</p>
        <div className="flex gap-1">{PERIODS.map(([d, l]) => (
          <button key={d} type="button" onClick={() => setDays(d)} data-testid={`dest-stats-period-${d}`} className={`rounded-full px-4 py-2 text-sm font-bold ${days === d ? "bg-[var(--ink)] text-white" : "bg-white"}`}>{l}</button>
        ))}</div>
      </div>
      {!rows ? <Loader2 className="h-5 w-5 animate-spin" /> : rows.length === 0
        ? <p data-testid="dest-stats-empty" className="rounded-3xl bg-white p-5 text-sm">Todavía no hay datos en este período. Se cuentan solos cuando los pasajeros tocan destinos en la franja de la portada.</p>
        : (
          <div className="overflow-x-auto rounded-3xl bg-white p-5">
            <table className="w-full min-w-[760px] text-left text-sm">
              <thead><tr className="text-[var(--muted-ink)]">{COLS.map((h) => <th key={h} className="pb-2 pr-3">{h}</th>)}</tr></thead>
              <tbody>{rows.map((r, i) => <StatRow key={r.city} r={r} i={i} max={max} onPromo={onPromo} />)}</tbody>
            </table>
          </div>
        )}
    </div>
  );
};
